module.exports = __webpack_public_path__ + "static/media/EFIKO_Logo_FINAL.2e5a66a8.png";